export const emailRegex = "[a-zA-Z0-9._-]+@[a-z0-9.-]+.[a-zA-Z]{2,5}";
//"[a-zA-Z0-9._-]+@[a-z0-9.-]+.[a-zA-Z]{2,5}$";
//"[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9_\-\.]+\.[a-zA-Z]{2,5}";


//"[a-zA-Z0-9._-]+@[a-z0-9.-]+.[a-zA-Z]{2,5}$"

//"^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$";


///:email([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,})

//[a-zA-Z0-9_\-\.]+@[a-z0-9.-]+\.[a-z]{2,}